import {useEffect, useState} from "react";
import {Role} from "../types/UserRole";
import {useRestClient} from "../client/SpmRestClient";
import {Spinner} from "react-bootstrap";
import {NamedEntityCheckboxGroup} from "zavadil-react-common";
import {useAlerts} from "../utils/UserAlerts";

export type SelectRolesProps = {
	selectedRoleIds: Array<number>;
	onChange(selectedRoleIds: Array<number>): any;
}

export default function SelectRoles({selectedRoleIds, onChange}: SelectRolesProps) {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [roles, setRoles] = useState<Array<Role>>();

	useEffect(() => {
			restClient.roles.all()
				.then(setRoles)
				.catch((e) => userAlerts.err(e));
		},
		[]
	);

	return roles ? <NamedEntityCheckboxGroup
		items={roles}
		selectedIds={selectedRoleIds}
		onChange={onChange}
	/> : <Spinner/>
}
